<!-- 页面布局-公共头部 -->
<template>
  <div class="page-header">
    <div class="nav-con">
      <!-- alt="segway-support" -->
      <div class="nav-left">
        <div class="logo-cn" v-if="environmentData.country == 'cn'">
          <svg-icon
            name="ic_nine_logo"
            @click="toExternalUrl(ninebotUrl, 'ninebot品牌')"
            class="logo-nine-icon" />
          <div class="vertical-line"></div>
          <div ref="segwayRef" class="segway-icon">
            <svg-icon
              name="ic_segway_logo"
              @mouseenter="handleMouseEnter"
              @mouseleave="handleMouseLeave"
              @click="toExternalUrl(ninebotSegwayUrl, 'segway品牌')"
              class="logo-segway-icon" />
          </div>
        </div>
        <svg-icon
          v-else
          name="ic_segway_black"
          @click="toExternalUrl(segwayUrl, 'segway品牌')"
          class="logo-segway-white-icon" />
        <div class="nav-items" ref="menuRef">
          <div
            v-for="item in menu"
            :key="item.url"
            :class="['nav-item', { none: typeof item === 'string' }]">
            <div
              v-if="item.children && item.children.length > 0"
              class="nav-active">
              <div class="nav-active-title">
                <div>{{ item.name }}</div>
                <svg-icon name="ic_arrow_down" class="ic-arrow-down" />
              </div>
              <div class="nav-active-content">
                <div class="nav-active-content-inner">
                  <div
                    v-for="child in item.children"
                    :key="child.url"
                    class="nav-active-content-inner-item"
                    @click="handleOpenUrl(child)">
                    {{ child.name }}
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else-if="typeof item === 'object'"
              @click="handleOpenUrl(item)">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <div>
        <svg-icon
          name="ic_search"
          class="s-icon-search nav-item s-icon"
          @click="changeSearch" />
        <svg-icon
          v-if="environmentData.country == 'us'"
          name="ic_shop"
          class="s-icon-shop nav-item s-icon"
          @click="toExternalUrl(storeSegwayUrl, '商城')" />
      </div>
      <Teleport to="body">
        <div class="header-search-container" v-if="showSearchInput">
          <div class="input-wrapper">
            <el-input
              v-model="searchInput"
              :maxlength="50"
              :placeholder="$t('search.pc_entry_placeholder')"
              @keyup.enter.native="changeFn"
              @focus="focusFn">
              <template #prefix>
                <svg-icon name="ic_search" class="s-search s-icon" />
              </template>
            </el-input>
            <SvgIcon
              name="ic_close_black"
              class="icon-close"
              v-if="searchInput"
              @click="handleClear" />
          </div>
          <SearchHeadHistory
            class="header-history"
            v-if="showHistory"
            :historyArr="historyArr"
            @searchHistory="searchHistory" />
        </div>
      </Teleport>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useLocalData, useUrl } from '@support/json';
import {
  OpenType,
  isEmpty,
  openInNewTabWithParams,
  environmentData
} from '@support/utils';
const { $sensorTrack } = useNuxtApp();
const { menu } = useLocalData();
const { ninebotUrl, ninebotSegwayUrl, segwayUrl, storeSegwayUrl } = useUrl();

const router = useRouter();

const segwayRef = ref<HTMLElement>();
const menuRef = ref<HTMLElement>();

const handleMouseEnter = () => {
  if (!segwayRef.value || !menuRef.value) return;
  segwayRef.value.style.transform = 'scale(1.4) translateX(10px)';
  segwayRef.value.style.transition = 'all 0.2s linear';
  menuRef.value.style.transform = 'translateX(20px)';
};
const handleMouseLeave = () => {
  if (!segwayRef.value || !menuRef.value) return;
  segwayRef.value.style.transform = 'scale(1) translateX(0)';
  menuRef.value.style.transform = 'translateX(0)';
};

onMounted(() => {
  if (!segwayRef.value) return;
  segwayRef.value.addEventListener('mouseenter', handleMouseEnter);
  segwayRef.value.addEventListener('mouseleave', handleMouseLeave);
});
onBeforeUnmount(() => {
  // 移除事件监听器
  if (!segwayRef.value) return;
  segwayRef.value.removeEventListener('mouseenter', handleMouseEnter);
  segwayRef.value.removeEventListener('mouseleave', handleMouseLeave);
});
function toExternalUrl(url: string, name: string) {
  $sensorTrack('navigation_bar_click', {
    click_type: name
  });
  useWindowsOpen(url);
}
function toHome() {
  router.push({
    path: '/'
  });
}
// 添加计算属性判断当前页面是否是配件价格页面
const isAccessoryPricePage = computed(() => {
  const route = useRoute();
  // 检查路由路径是否包含accessoryPrices或者包扣accessoryPrices/search
  if (route.path.includes('/accessoryPrices')) {
    return 1;
  } else if (route.path.includes('/accessoryPrices/search')) {
    return 2;
  }
});
function handleOpenUrl(item: any) {
  $sensorTrack('navigation_bar_click', {
    click_type: environmentData.country == 'cn' ? item.clickTypeName : item.name
  });
  if (Number(item.openType) == OpenType.backHome) {
    // 判断是配件价格页面 判断一下国家
    if (environmentData.country == 'cn' && isAccessoryPricePage.value) {
      $sensorTrack('click', {
        pg_id: isAccessoryPricePage.value === 1 ? 'svc_ftg' : 'svc_ftg_dpg',
        btn_nm: '服务支持'
      });
    }
    toHome();
    return;
  }
  useWindowsOpen(item.url);
}

defineProps({
  showSearchInput: {
    type: Boolean,
    default: false
  },
  isShowSubmit: {
    type: Boolean,
    default: false
  },
  isShowHistory: {
    type: Boolean,
    default: false
  }
});

const emits = defineEmits([
  'showSearch',
  'hideSearch',
  'showSubmit',
  'showHistory',
  'hideHistory'
]);
const searchInput = ref('');
const historyArr = ref<String[]>([]);
let showHistory = ref(false);

const handleClear = () => {
  searchInput.value = '';
};
const focusFn = () => {
  // 展示提交按钮
  emits('showSubmit');
};

const searchHistory = (htyItem: any) => {
  emits('hideSearch');
  if (htyItem.trim().length > 0) {
    historyArr.value.unshift(htyItem);
    localStorage.setItem('search-history', JSON.stringify(historyArr.value));
  }
  openInNewTabWithParams({
    path: '/search',
    query: {
      keyword: htyItem
    }
  });
};
const searchCom = () => {
  if (searchInput.value.trim() === '') return;
  emits('hideSearch');
  const trimValue = searchInput.value.trim();
  openInNewTabWithParams({
    path: '/search',
    query: {
      keyword: trimValue
    }
  });
  const findIndex = historyArr.value.indexOf(trimValue);
  if (findIndex > -1) {
    historyArr.value.splice(findIndex, 1);
  }
  if (trimValue.length > 0) {
    historyArr.value.unshift(searchInput.value);
    localStorage.setItem('search-history', JSON.stringify(historyArr.value));
  }
  setTimeout(() => {
    searchInput.value = '';
  });
};
const searchFn = () => {
  searchCom();
};
const changeFn = () => {
  searchCom();
};
const changeSearch = () => {
  $sensorTrack('navigation_bar_click', {
    click_type: '搜索'
  });
  searchInput.value = '';
  showHistory.value = localStorage.getItem('search-history') ? true : false;
  // 展示历史记录
  const historyList = localStorage.getItem('search-history');
  if (!historyList) {
    emits('hideHistory');
  } else {
    const hObj = [...new Set(JSON.parse(historyList))];
    if (hObj.length === 0) {
      emits('hideHistory');
    } else {
      emits('showHistory');
      historyArr.value = hObj.length > 5 ? hObj.slice(0, 5) : hObj;
    }
  }
  emits('showSearch');
};
</script>
<style lang="scss" scoped>
.page-header {
  min-width: 100%;
  height: 60px;
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  position: absolute;
  top: 0;
  z-index: 500;
}
.nav-con {
  display: flex;
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  justify-content: space-between;
  align-items: center;
  .nav-left {
    display: flex;
    align-items: center;
    .logo-cn {
      display: flex;
      justify-content: center;
      align-items: center;
      .logo-nine-icon {
        width: 112px;
        height: 24px;
        cursor: pointer;
        transition: transform 0.2s linear;
      }
      .segway-icon {
        width: 73px;
        height: 24px;
        margin-right: 48px;
        .logo-segway-icon {
          width: 73px;
          height: 24px;
          cursor: pointer;
        }
      }

      .vertical-line {
        width: 1px;
        height: 20px;
        background: rgb(234, 234, 234);
        margin: 0 12px;
      }
    }
    .logo-segway-white-icon {
      width: 118px;
      height: 24px;
      margin-right: 28px;
      cursor: pointer;
    }
  }
  .nav-items {
    height: 60px;
    line-height: 60px;
    transition: transform 0.2s ease;
    .nav-item {
      &.none {
        display: none;
      }
      flex-shrink: 0;
      display: inline-block;
      padding: 0 18px;
      font-size: 14px;
      color: #000000;
      cursor: pointer;
      position: relative;
      .nav-active {
        .nav-active-title {
          display: flex;
          align-items: center;
          justify-content: center;
          .ic-arrow-down {
            flex-shrink: 0;
            width: 12px;
            height: 12px;
            margin-left: 8px;
            transform: rotate(0deg);
          }
        }
        .nav-active-content {
          position: absolute;
          left: 5px;
          top: 60px;
          width: max-content;
          border-radius: 8px;
          z-index: 100;
          background-color: #ffffff;
          display: none;
          .nav-active-content-inner {
            padding: 16px;
            .nav-active-content-inner-item {
              margin-bottom: 20px;
              color: #000000;
              font-size: 13px;
              cursor: pointer;
              line-height: initial;
              &:hover {
                color: #f30000;
              }
              &:active {
                color: #c40001;
              }
            }
            .nav-active-content-inner-item:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }
    .nav-item:hover {
      cursor: pointer;
      color: #f30000;
      .nav-active-title .ic-arrow-down {
        transform: rotate(180deg);
        color: #f30000;
      }
      .nav-active-content {
        display: block;
      }
    }
  }
  .s-icon {
    padding: 18px 0 18px 6px;
    cursor: pointer;
    vertical-align: bottom;
  }
  .s-search {
    width: 24px;
    height: 24px;
    margin-left: 16px;
    color: #86868b;
  }
  .s-icon-search {
    width: 20px;
    height: 20px;
  }
  .s-icon-shop {
    width: 20px;
    height: 20px;
    margin-left: 10px;
  }
}
</style>
<style lang="scss">
.header-search-container {
  background-color: #ffffff;
  border-radius: 0 0 24px 24px;
  padding: 24px 48px;
  position: fixed;
  top: 60px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 600;
  .input-wrapper {
    width: 648px;
    height: 48px;
    position: relative;
  }
  .el-input {
    width: 100%;
    height: 100%;
  }
  .el-input__wrapper {
    background-color: #f3f3f4;
    border-radius: 50px;
    box-shadow: none !important;
    padding-left: 0;
  }
  :deep(.el-input__inner) {
    font-size: 16px !important;
    padding-right: 35px;
    box-sizing: border-box;
  }
  .icon-close {
    width: 24px;
    height: 24px;
    position: absolute;
    top: 50%;
    right: 15px;
    transform: translate(0, -50%);
    cursor: pointer;
  }
  .s-search {
    width: 24px;
    height: 24px;
    margin-left: 16px !important;
    color: #86868b;
  }
  .el-button {
    // width: 64px;
    height: 32px;
    position: absolute;
    top: 50%;
    right: 8px;
    transform: translate(0, -50%);
    font-size: 16px;
    line-height: 32px;
    font-weight: normal;
    padding: 8px 15px; // 这个padding是 button 本身有的， 设置下可以缩放，否则缩小不成功
  }
  .header-history {
    width: 648px;
    margin-top: 32px;
    border-top-right-radius: 0;
    border-top-left-radius: 0;
  }
}
</style>
